import React, { useEffect, useState } from "react"
import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"
import DownNav from "../../../../assets/icons/wild/wild-caret-down.svg"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

const FullWrap = styled.div``

const Mobile = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    display: none;
  }
`
const Desktop = styled(Flex)`
  width: 100%;
  display: none;
  @media (min-width: 768px) {
    display: flex;
  }
`

const ButtonsWrap = styled(Flex)`
  margin-left: auto;
  flex-direction: column;
`
const ButtonsHolder = styled.div`
  position: relative;
  width: 100%;
  background: ${theme.color.white};
  border-radius: 8px;
  margin: 8px 0;
  padding: 0;
  height: auto;
  z-index: 5;
`

const ButtonsFloat = styled.div`
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  padding: 0 0 8px 0;
  background: ${theme.color.white};
  border-radius: 8px;
  border: 1px solid ${theme.wild.color.master.primary.alt};
`

const OptionWrap = styled.button`
  width: 100%;
  height: 56px;
  background: #f8f8f5;
  &.active {
    background: ${theme.wild.color.master.primary.alt};
  }

  border-radius: 8px;

  @media (min-width: 768px) {
    height: 79px;
  }

  span,
  svg {
    display: inline-block;
  }

  &.normal {
    border-radius: 8px;
    padding: 8px 9px;
  }

  &.float {
    height: 56px;
    width: 96%;
    margin: 4px 2%;
    &.option-0 {
      margin: 8px 2% 4px;
    }
    &.option-last {
      margin: 4px 2% 0;
    }
    .plus-icon {
      visibility: hidden;
    }
  }
`

const OptionRow = styled(Flex)`
  flex-direction: row;
  text-align: left;
  img {
    height: 38px;
  }

  .plus-icon {
    width: 14px;
    padding: 0;
  }
  .with-info .textelement[class*="body--"][class*="-b "] {
    @media (max-width: 420px) {
      font-size: 12px;
    }
  }
`

const OptionWrapDesk = styled(Box)`
  border-radius: 8px;
  margin: 0 8px 8px 0;
  flex: 1;
  &.opt4 {
    margin-right: 0 !important;
  }
  > button {
    background: #f8f8f5;
  }
  &.active {
    > button {
      background: ${theme.wild.color.master.primary.alt};
    }
  }
`

const OptionRowDesk = styled(Flex)`
  align-items: center;
  justify-content: center;

  img {
    height: 48px;
    @media (min-width: 768px) and (max-width: 1023px) {
      height: 36px;
    }
    @media (min-width: 1120px) {
      padding-right: 16px;
    }
  }
  > div {
    margin: auto;
  }
  .option-core {
    @media (min-width: 768px) and (max-width: 1023px) {
      font-size: 12px !important;
      max-width: 75px;
    }
  }
`

const EditorialSelect = ({ data, setIngrOption, ingrOption, showInfo }) => {
  const [isFloat, setIsFloat] = useState(false)

  useEffect(() => {
    if (typeof document !== "undefined") {
      const handleClick = (evt) => {
        evt = evt || window.event
        if (
          Array.from(evt.target.classList).indexOf("buttonsfloat") === -1 &&
          isFloat
        ) {
          setIsFloat(false)
        }
      }
      const handleKey = function (evt) {
        evt = evt || window.event
        var isEscape =
          evt &&
          (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27)
        if (isEscape) {
          if (isFloat) {
            setIsFloat(false)

            const header = document.querySelector("header")
            const main = document.querySelector("main")
            const footer = document.querySelector("footer")

            header && header.setAttribute("data-mousedown", "1")
            main && main.setAttribute("data-mousedown", "1")
            footer && footer.setAttribute("data-mousedown", "1")
          }
        }
      }
      document.addEventListener("click", handleClick)
      document.addEventListener("keydown", handleKey)
      return () => {
        document.removeEventListener("click", handleClick)
        document.removeEventListener("keydown", handleKey)
      }
    }
  }, [isFloat])

  const options = data.map((el, idx) => {
    return {
      title: el.name,
      core: el.core,
      image: el.dropdownImg,
      value: idx,
      info: el.info,
    }
  })

  const onSelect = (idx) => {
    setIngrOption(idx)
    const option = options[idx]
    segmentEvent("Module Tab Clicked", {
      module_location: "mid_fold",
      text: option.title,
    })
  }

  const onOpen = () => {
    // const option = options[ingrOption]
  }

  const renderOption = (idx, type = "normal") => {
    const option = options[idx]
    let isVegan = option.title.indexOf("Vegan") !== -1
    let cls = idx
    if (idx === options.length - 1) {
      cls = "last"
    }

    return (
      <OptionWrap
        key={`opt${idx}`}
        className={`option-${cls} ${isVegan ? "vegan" : ""} ${type} ${
          ingrOption === idx ? "active" : ""
        }`}
        onClick={(e) => {
          if (type === "float") {
            onSelect(idx)
          } else {
            e.nativeEvent.stopImmediatePropagation()
            setIsFloat(true)
            onOpen()
          }
        }}
      >
        <OptionRow data-sku={option?.sku}>
          <Box width={[56]}>
            <img src={`${option.image}&h=96`} alt="" />
          </Box>
          <Flex
            width={[0.73]}
            pt={[10]}
            mr="auto"
            className={showInfo ? "with-info" : ""}
          >
            <TextElement
              element="p"
              text={option.title}
              className={"body--xlarge-b"}
            />
            {showInfo && option.info ? (
              <TextElement
                element="p"
                text={`&nbsp;&nbsp;•&nbsp;&nbsp;${option.info}`}
                className={"body--xlarge-b"}
              />
            ) : null}
          </Flex>
          <Box width={[0.07]} pt={[1]}>
            <DownNav className="plus-icon" />
          </Box>
        </OptionRow>
      </OptionWrap>
    )
  }

  const renderOptionDesk = (idx) => {
    const option = options[idx]
    let isVegan = option.title.indexOf("Vegan") !== -1

    return (
      <OptionWrapDesk
        key={`opt${idx}`}
        className={`desktop-option opt${idx} ${isVegan ? "vegan" : ""} ${
          ingrOption === idx ? "active" : ""
        }`}
      >
        <OptionWrap
          onClick={(e) => {
            onSelect(idx)
          }}
        >
          <OptionRowDesk data-sku={option?.sku}>
            <img src={`${option.image}&h=96`} alt="" />
            <span className="text-center">
              <TextElement
                element="p"
                text={option.core}
                className={"body--large option-core"}
              />
              {showInfo && option.info ? (
                <TextElement
                  element="p"
                  text={option.info}
                  className={"body--small"}
                />
              ) : null}
            </span>
          </OptionRowDesk>
        </OptionWrap>
      </OptionWrapDesk>
    )
  }

  const mapper = options.map
    ? options.map((el, idx) => renderOption(idx, "float"))
    : null
  const mapperdesk = options.map
    ? options.map((el, idx) => renderOptionDesk(idx))
    : null

  return (
    <FullWrap>
      <Desktop>{mapperdesk}</Desktop>
      <Mobile>
        <ButtonsWrap>
          <ButtonsHolder>
            {renderOption(ingrOption)}
            {isFloat && (
              <ButtonsFloat className={`buttonsfloat`}>{mapper}</ButtonsFloat>
            )}
          </ButtonsHolder>
        </ButtonsWrap>
      </Mobile>
    </FullWrap>
  )
}

export default EditorialSelect
